import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// 3D Pay ödeme başlatma
export const initiate3DPayment = async (paymentData) => {
  try {
    const initPayment = httpsCallable(functions, 'initiate3DPayment');
    const result = await initPayment(paymentData);
    return result.data;
  } catch (error) {
    console.error('Ödeme başlatma hatası:', error);
    throw error;
  }
};

// ✅ İptal işlemi (orderDate ile batch kontrolü)
export const cancelQNBPayment = async (orderId, orderDate = null) => {
  try {
    console.log('💳 Frontend: QNB iptal fonksiyonu çağrılıyor:', { orderId, orderDate });
    
    const cancel = httpsCallable(functions, 'cancelPayment');
    const result = await cancel({ 
      orderId: orderId,
      orderDate: orderDate  // ✅ Batch kontrolü için
    });
    
    console.log('✅ Frontend: QNB iptal sonucu:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Frontend: İptal hatası:', error);
    console.error('❌ Frontend: Error details:', error.message);
    throw error;
  }
};

// ✅ İade işlemi
export const refundQNBPayment = async (orderNumber, amount) => {
  try {
    console.log('💰 Frontend: QNB iade fonksiyonu çağrılıyor:', { orderNumber, amount });
    
    const refund = httpsCallable(functions, 'refundPayment');
    const result = await refund({ orderId: orderNumber, amount });
    
    console.log('✅ Frontend: QNB iade sonucu:', result.data);
    return result.data;
  } catch (error) {
    console.error('❌ Frontend: İade hatası:', error);
    console.error('❌ Frontend: Error details:', error.message);
    throw error;
  }
};

// ✅ ESKI FONKSİYONLAR (Backward Compatibility)
export const cancelPayment = cancelQNBPayment;
export const refundPayment = refundQNBPayment;